import { createFeature, createReducer, on } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import { AuthActions } from '../auth';
import { initialPaymentCardState } from './payment-state.model';
import { PaymentActions } from './payment.actions';

export const paymentReducer = createReducer(
  initialPaymentCardState,
  on(PaymentActions.loadPaymentCardsSuccess, (state, { cards }) => {
    return { ...state, cards };
  }),
  on(PaymentActions.removePaymentCards, (state, { cardId }) => {
    state = cloneDeep(state);
    const index: number = state.cards.findIndex((card) => card.id === cardId);
    if (index !== -1) {
      state.cards.splice(index, 1);
    }
    return { ...state, cards: state.cards };
  }),
  on(AuthActions.logout, (state) => {
    return { ...state, cards: [] };
  })
);

export const paymentFeature = createFeature({
  name: 'payment',
  reducer: paymentReducer,
});
